import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "adbout-us-page common-page"
};
import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElForm } from 'element-plus';
import { aboutUsApi, updateAboutUsApi } from '@/service/modules/sea';
export default /*@__PURE__*/_defineComponent({
  __name: 'about-us',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const id = ref(1);
    const form = reactive({
      contactPhone: '',
      contactEmail: '',
      workTime: ''
    });
    const isLoading = ref(false);
    const formRules = {
      contactPhone: [{
        required: true,
        message: '请输入联系电话',
        trigger: 'blur'
      }],
      contactEmail: [{
        required: true,
        message: '请输入联系邮箱',
        trigger: 'blur'
      }, {
        pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/,
        message: '请输入正确的邮箱格式',
        trigger: 'blur'
      }],
      workTime: [{
        required: true,
        message: '请输入工作时间',
        trigger: 'blur'
      }]
    };
    getAboutUs();
    // 关于我们
    async function getAboutUs() {
      try {
        let res = await aboutUsApi();
        console.log('res.data', res.data);
        form.contactPhone = res.data.contactPhone;
        form.contactEmail = res.data.contactEmail;
        form.workTime = res.data.workTime;
      } catch {} finally {}
    }
    function handleToBack() {
      router.back();
    }
    async function handleSubmit() {
      console.log('form', form);
      isLoading.value = true;
      try {
        await updateAboutUsApi(form);
        ElMessage.success('修改成功');
      } catch {} finally {
        isLoading.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElForm), {
        "label-position": "left",
        "label-width": "100px",
        rules: formRules,
        ref: "formRef",
        style: {
          "width": "600px"
        },
        model: form
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "联系电话",
          prop: "contactPhone"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.contactPhone,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.contactPhone = $event),
            placeholder: "请输入联系电话"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "联系邮箱",
          prop: "contactEmail"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.contactEmail,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.contactEmail = $event),
            placeholder: "请输入邮箱"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "工作时间",
          prop: "workTime"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.workTime,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.workTime = $event),
            placeholder: "请输入工作时间"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "danger",
            style: {
              "margin-right": "10px"
            },
            size: "default",
            onClick: handleToBack
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("返回")])),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            size: "default",
            onClick: handleSubmit,
            loading: isLoading.value
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("确定")])),
            _: 1
          }, 8, ["loading"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]);
    };
  }
});